import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import meta from '../../config/meta';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Badges from '../blocks/Badges.jsx';

const PageBadges = () => {
  meta.set({ title: '我的獎章' });

  const [, req] = useHttpStatus();
  useEffect(() => {
    req({
      method: 'patch',
      url: '/api/quiz/badges',
    });
  }, []);

  return (
    <div className="py-4">
      <div className="container">
        <div>
          <Link to="/app/profile" className="text-primary" >
            <img
              className="mr-3 mt-n1"
              src="/assets/img/long-arrow-left.svg"
              style={{ width: '50px' }}
            />
            返回我的帳戶
          </Link>
        </div>
        <h3 className="text-center my-4">
          我的獎章
        </h3>
        <Badges all />
      </div>
    </div>
  );
};

export default PageBadges;
